import React, { useEffect, useState } from "react";
import "./fundraiserAssets.scss";
import Loader from "../../common/Loader";
import { getMyAssets, getAssetDetails } from "../../../services/assetsService";
import { getFileFromS3 } from "../../../utils/s3";

import APostersIcon from '../../../Assets/Images/Fundraiser/A-Posters.svg';
import DownloadIcon from '../../../Assets/Images/Fundraiser/Download-Icon.svg';
import EFlyersIcon from '../../../Assets/Images/Fundraiser/E-Flyers.svg';
import EmailTemplatesIcon from '../../../Assets/Images/Fundraiser/Email-Templates.svg';
import PostCardsIcon from '../../../Assets/Images/Fundraiser/Post-Cards.svg';
import QRCodesIcon from '../../../Assets/Images/Fundraiser/QR-Codes.svg';
import SocialMediaBannersIcon from '../../../Assets/Images/Fundraiser/Social-Media-Banners.svg';
import { PiFlagBannerLight } from 'react-icons/pi'; // Fixed: use existing icon for Pull up banners
// (Email Signatures now uses a project SVG asset)
import EmailSignatureIcon from '../../../Assets/Icons/emailsignature.svg';
// import EmptyState from '../Marketing/EmptyState';
// import noDataIllustration from '../../../Assets/Images/Fundraiser/No data-cuate 1.svg';

const FundraiserAssets = () => {
  const [assetsList, setAssetsList] = useState();
  // const [selectedAsset, setSelectedAsset] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  // (initialValues not needed)

  // const { sale } = formik.values;

  // (handleSalesChange is not used)

  useEffect(() => {
    fetchAssets();
  }, []);

  useEffect(() => {
    const fetchInitialAssetDetails = async () => {
      if (assetsList && assetsList.length > 0) {
        try {
          const response = await getAssetDetails(assetsList[0]._id);
          if (response?.data?.success) {
            // setSelectedAsset(response.data.data); // This line was removed
          }
        } catch (error) {
          console.error("Error fetching initial asset details:", error);
        }
      }
    };
    fetchInitialAssetDetails();
  }, [assetsList]);

  const fetchAssets = async () => {
    try {
      setIsLoading(true);
      const response = await getMyAssets();
      if (response?.data?.success) {
        setAssetsList(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching assets:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const assetCategories = [
    { key: 'postcards', label: 'Postcards', icon: <img src={PostCardsIcon} alt="Postcards" className="w-9 h-9" /> },
    { key: 'a1Posters', label: 'A1 Posters', icon: <img src={APostersIcon} alt="A1 Posters" className="w-7 h-7" /> },
    { key: 'a2Posters', label: 'A2 Posters', icon: <img src={APostersIcon} alt="A2 Posters" className="w-7 h-7" /> },
    { key: 'a3Posters', label: 'A3 Posters', icon: <img src={APostersIcon} alt="A3 Posters" className="w-7 h-7" /> },
    { key: 'a4Posters', label: 'A4 Posters', icon: <img src={APostersIcon} alt="A4 Posters" className="w-7 h-7" /> },
    { key: 'socialMediaBanners', label: 'Social Media Banners', icon: <img src={SocialMediaBannersIcon} alt="Social Media Banners" className="w-9 h-9" /> },
    { key: 'digitalFlyer', label: 'E Flyers', icon: <img src={EFlyersIcon} alt="E Flyers" className="w-9 h-9" /> },
    { key: 'qrCodes', label: 'QR Codes', icon: <img src={QRCodesIcon} alt="QR Codes" className="w-7 h-7" /> },
    { key: 'emailTemplates', label: 'Email Templates', icon: <img src={EmailTemplatesIcon} alt="Email Templates" className="w-9 h-9" /> },
    { key: 'pullUpBanners', label: 'Pull up Banners', icon: <span style={{ color: '#00ADEF' }}><PiFlagBannerLight size={26} /></span> },
    // UPDATED for Email Signatures (using provided SVG)
    { key: 'emailSignatures', label: 'Email Signatures', icon: <img src={EmailSignatureIcon} alt="Email Signatures" className="w-7 h-7" /> },
  ];

  const downloadAsset = async (asset) => {
    if (!asset?.file) return;
    try {
      setIsDownloading(true);
      const fileData = await getFileFromS3(asset.file);
      const blob = new Blob([fileData], { type: 'application/octet-stream' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = asset.file;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
    } finally {
      setIsDownloading(false);
    }
  };

  // Map assets to categories for quick lookup
  const availableAssets = {};
  assetsList?.forEach(asset => {
    // If asset has a category, use it; otherwise, assign to first available category
    if (asset.category) {
      availableAssets[asset.category] = asset;
    } else {
      // For assets without category, assign to the first category that doesn't have an asset yet
      const firstEmptyCategory = assetCategories.find(cat => !availableAssets[cat.key]);
      if (firstEmptyCategory) {
        availableAssets[firstEmptyCategory.key] = asset;
      }
    }
  });

  return (
    <>
      {isLoading && <Loader />}
      <div className="flex flex-col gap-3 md:gap-5">
        <h1 className="text-[18px] md:text-[22px] font-[600] text-[#303030] mt-4 mb-1 md:mb-2">Marketing Assets</h1>
      </div>
      <div className="bg-white rounded-xl shadow-md mt-4 md:mt-6 p-4 md:p-6">
        <h2 className="text-sm md:text-base font-semibold text-[#303030] mb-4 md:mb-6">View and Download Artwork for Your Fundraiser Campaign</h2>
        <div className="flex flex-col md:flex-row md:flex-wrap gap-4 md:gap-6">
          {assetCategories.map((cat, idx) => {
            const asset = availableAssets[cat.key];
            const isAvailable = !!asset;
            return (
              <div
                key={cat.key}
                className={`flex flex-row items-center justify-between border transition-all duration-200 rounded-lg w-full md:w-[200px] h-[60px] md:h-[47px] px-4 py-0 text-center ${isAvailable
                  ? 'border-[#00ADEF] bg-gradient-to-r from-[#00ADEF]/10 to-[#00ADEF]/5 shadow-sm hover:shadow-md'
                  : 'border-gray-200 bg-white hover:bg-gray-50'
                  }`}
              >
                <div className="flex items-center gap-3 w-full">
                  <span className="flex items-center justify-center w-10 flex-shrink-0">{cat.icon}</span>
                  <span className={`font-medium text-left break-words leading-tight ${cat.key === 'social_media_banners' ? 'text-[13px]' : 'text-[13px]'}`}>
                    {cat.label}
                  </span>
                </div>
                <button
                  className={`ml-2 flex items-center justify-center rounded-full w-8 h-8 md:w-auto md:h-auto md:bg-transparent ${isAvailable ? 'text-[#00ADEF] cursor-pointer bg-[#00ADEF]/10 md:bg-transparent' : 'text-gray-300 cursor-not-allowed'
                    }`}
                  onClick={() => isAvailable && downloadAsset(asset)}
                  disabled={!isAvailable || isDownloading}
                >
                  <img src={DownloadIcon} alt="Download" className="w-5 h-5" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default FundraiserAssets;
